import { render, staticRenderFns } from "./LeavesListDeclined.vue?vue&type=template&id=051c07b9&scoped=true"
import script from "./LeavesListDeclined.vue?vue&type=script&lang=js"
export * from "./LeavesListDeclined.vue?vue&type=script&lang=js"
import style0 from "./LeavesListDeclined.vue?vue&type=style&index=0&id=051c07b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c07b9",
  null
  
)

export default component.exports